export const Topup = {
  STANDARD: 'standard',
  INTERNET: 'internet',
};

export type TopupsKeys = keyof typeof Topup;
export type TopupType = typeof Topup[TopupsKeys];

export default Topup;
